module.exports = __webpack_public_path__ + "img/activarKit.c663c5c7.svg";